import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, getCurrentInstance } from 'vue';
import {
  XrkTable,
  XrkTableProps,
  useTableColumn,
  useInputColumn,
  BaseButton,
  useCreateModal
} from 'xrk-components';
import { formatter } from '@/utils';
import { notInvoicedList } from '@V/invoice/src/data-source/apis';
import type { NotInvoicedListParams } from '@V/invoice/src/data-source/types';
import { ORDER_TYPE } from '@constants/order';
import {
  projectNameSearch,
  userDefinedOrderNoSearch,
  userDefinedOrderTypeSearch,
  settlementNoSearch,
  projectServiceFeeOrderNoSearch
} from '@V/invoice/src/fields/searchs';
import {
  purchaserNameCol,
  projectNameCol,
  userDefinedOrderTypeCol,
  theSellerNameCol,
  receiveAtCol,
  settlementNoCol,
  projectServiceFeeOrderNoCol,
  orderNoCol
} from '@V/invoice/src/fields/columns';
import InvoiceOpenDialog from '../invoice-open-dialog';

/** 平台发票订单类型：平台服务费/商务服务费/技术服务费 */

export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-uninvoiced-list-platform',
  setup(__props) {

const PLATFORM_ORDER_TYPES = [ORDER_TYPE[4], ORDER_TYPE[5], ORDER_TYPE[8]];

const xrkTableRef = ref();

const getListAjax = async (params: NotInvoicedListParams) => {
  return notInvoicedList(params);
};

const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchColumns: [
    useInputColumn({
      prop: 'theSellerName',
      label: '销售方',
      config: { placeholder: '请输入', clearable: true }
    }),
    projectNameSearch(),
    settlementNoSearch(),
    projectServiceFeeOrderNoSearch(),
    userDefinedOrderNoSearch(),
    userDefinedOrderTypeSearch(PLATFORM_ORDER_TYPES)
  ],
  searchBtn: { show: true, text: '搜索' },
  resetBtn: { show: true, text: '重置' },
  otherComponents: [
    {
      render() {
        return (
          <BaseButton
            v-resource={[['未开票订单_申请开票']]}
            type="primary2"
            click={async () => {
              useCreateModal(
                InvoiceOpenDialog,
                {
                  tabKey: 3,
                  onSuccess() {
                    xrkTableRef.value.initCurrentList();
                  }
                },
                getCurrentInstance()
              );
            }}
          >
            申请开票
          </BaseButton>
        );
      }
    }
  ]
});

const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [
    useTableColumn({ type: 'index', label: '序号', width: '80px' }),
    purchaserNameCol(),
    projectNameCol(),
    settlementNoCol(),
    projectServiceFeeOrderNoCol(),
    orderNoCol(),
    userDefinedOrderTypeCol(),
    theSellerNameCol(),
    receiveAtCol(),
    useTableColumn({
      label: '金额（元）',
      prop: 'userDefinedPrice',
      width: '180px',
      formatter: ({ cellValue }) => formatter.fen2yuan(cellValue)
    })
  ]
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(XrkTable), {
    ref_key: "xrkTableRef",
    ref: xrkTableRef,
    getListAjax: getListAjax,
    searchConfig: searchConfig.value,
    tableConfig: tableConfig.value
  }, null, 8, ["searchConfig", "tableConfig"]))
}
}

})